// メッセージMap
export const MessageMap = {
    enquete_answer_contents: '評価コメント',
    enquete_answer_status: 'ステータス'
};
